import { render } from "./SimulationPanel.vue?vue&type=template&id=796352c8&scoped=true"
import script from "./SimulationPanel.vue?vue&type=script&lang=js"
export * from "./SimulationPanel.vue?vue&type=script&lang=js"

import "./SimulationPanel.vue?vue&type=style&index=0&id=796352c8&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2-stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796352c8"]])

export default __exports__